// Shared display helpers for walk issue reports.
// Category keys mirror the 7 stable keys the Flutter report dialog submits
// (lib/src/module/walk/walk_post_screen.dart). Keep in sync if those change.

export const CATEGORY_LABELS = {
  distance: "Distance was inaccurate",
  route_map: "Route or map was wrong / missing",
  gps: "GPS jumped or was inaccurate",
  pause_stop: "Walk paused or stopped on its own",
  not_saved: "Walk didn't save / lost walk",
  crash: "App froze or crashed mid-walk",
  other: "Other",
};

export const categoryLabel = (key) => CATEGORY_LABELS[key] || key || "—";

// tracking_engine is "A" (legacy walk_controller), "B" (Track B), or null
// for pre-0019 walks / un-synced reports.
export const engineLabel = (engine) => (engine ? `Track ${engine}` : "—");
